module.exports = __webpack_public_path__ + "img/IMG_6728.417a2d53.jpeg";